import src from "IMAGE";
export default { src, width: 167, height: 142, blurWidth: 0, blurHeight: 0};
